import { cardCSSVars, makeStyles, tokens } from '@fluentui/react-components';
import { CARD_BORDER_RADIUS } from '@shared/constants/card.constants';
import { SQUARE_CARD_WIDTH } from './Square.constants';

export const useSquareCardStyles = makeStyles({
  card: {
    [cardCSSVars.cardBorderRadiusVar]: CARD_BORDER_RADIUS,
    width: SQUARE_CARD_WIDTH,
    transitionProperty: 'box-shadow',
    transitionDuration: tokens.durationFaster,
    transitionTimingFunction: tokens.curveEasyEase,
    '&:hover': {
      backgroundColor: tokens.colorNeutralBackground1,
      boxShadow: tokens.shadow8,
    },
    '&:active': {
      backgroundColor: tokens.colorNeutralBackground1,
      boxShadow: tokens.shadow4,
    },
  },
  title: {
    color: tokens.colorNeutralForeground1,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    textOverflow: 'ellipsis',
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase400,
  },
  // The 3-dot button stays visible while its menu is open, even after the pointer leaves the card.
  revealActions: {
    '& .fui-CardHeader__action .fui-Button:not([aria-expanded="true"])': { opacity: 0 },
    '&:hover .fui-CardHeader__action .fui-Button': { opacity: 1 },
    '&:focus-within .fui-CardHeader__action .fui-Button': { opacity: 1 },
    '@media (hover: none)': {
      '& .fui-CardHeader__action .fui-Button:not([aria-expanded="true"])': { opacity: 1 },
    },
  },
});
